export const cardColor = {
    default:"black",
    active:"#8ccae4",
    correct:"#73e673",
    wrong:"#f15757",
}